<script lang="ts">
  // Xert's difficulty rating: five diamonds, filled in half steps.
  export let value: number // 0 to 5
  export let size = 30
  export let color = 'currentColor'
  export let empty = 'currentColor'
  export let emptyOpacity = 0.22

  const uid = Math.random().toString(36).slice(2, 8)
</script>

<span class="xr-diamonds" style="gap: {size * 0.18}px;">
  {#each [0, 1, 2, 3, 4] as i}
    {@const fill = Math.max(0, Math.min(1, value - i))}
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
      <defs>
        <clipPath id="d-{uid}-{i}"><rect x="0" y="0" width={24 * fill} height="24" /></clipPath>
      </defs>
      <path d="M12 1 23 12 12 23 1 12Z" style="fill: {empty}" fill-opacity={emptyOpacity} />
      {#if fill > 0}
        <path d="M12 1 23 12 12 23 1 12Z" style="fill: {color}" clip-path="url(#d-{uid}-{i})" />
      {/if}
    </svg>
  {/each}
</span>

<style>
  .xr-diamonds {
    display: inline-flex;
    align-items: center;
  }
  svg {
    display: block;
  }
</style>
